module.exports = __webpack_public_path__ + "img/moneybox_01.871472a3.png";